'use client';

import React, { JSX } from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { 
	ICON_BUY, 
	ICON_HOME, 
	ICON_USER, 
} from '@/constants/icons';
import {
	TX_ERR_404_ACTIONS_HEADER,
	TX_ERR_404_COPY,
	TX_ERR_404_TITLE,
	TX_HOME,
	TX_MENU_SECTION_ACCOUNT,
	TX_SHOP,
} from '@/constants/strings';
import { 
	URL_ACCOUNT, 
	URL_BUY_GENERAL, 
	URL_HOME, 
} from '@/constants/urls';

import useAuth from '@/hooks/useAuth';
import useStore from '@/hooks/useStore';

import Icon from '@/components/Icons/Icon';

import './style/_error.scss';

// Prop types
interface Error404Props {
  
}

const Error404 = (props: Error404Props): JSX.Element | null => {

	// Internationalization
	const { t } = useTranslation();

	// Auth
	const { isLoggedIn } = useAuth();

	// Store
	const { store } = useStore();

	return (
		<div className='Error404'>
			<div className='errorHeader'>
				<div className='titleWrapper'>
					<div className='pageTitle'>
						<div className='pageErrorCode'>404</div>
						<div className='pageTitleCopy'>{t(TX_ERR_404_TITLE)}</div>
					</div>
				</div>
			</div>
			<div className='errorBody'>
				<div className='bodyCopy'>{t(TX_ERR_404_COPY)}</div>
				{store && <div className='bodyActionHeader'>{t(TX_ERR_404_ACTIONS_HEADER, { name: store?.name || '' })}</div>}
				{isLoggedIn !== null && (
					<div className='bodyActionsWrapper'>
						<div className='bodyAction'>
							<div className='actionIcon'>
								<Icon value={ICON_HOME} iconClass={'icon'} />
							</div>
							<Link href={URL_HOME} className='actionLink'>
								<button type='button' className='actionButton'>{t(TX_HOME)}</button>
							</Link>
						</div>
						<div className='bodyAction'>
							<div className='actionIcon'>
								<Icon value={ICON_BUY} iconClass={'icon'} />
							</div>
							<Link href={URL_BUY_GENERAL} className='actionLink'>
								<button type='button' className='actionButton'>{t(TX_SHOP)}</button>
							</Link>
						</div>
						{isLoggedIn && (
							<div className='bodyAction'>
								<div className='actionIcon'>
									<Icon value={ICON_USER} iconClass={'icon'} />
								</div>
								<Link href={URL_ACCOUNT} className='actionLink'>
									<button type='button' className='actionButton'>{t(TX_MENU_SECTION_ACCOUNT)}</button>
								</Link>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default Error404;
